import { render, staticRenderFns } from "./BasicTenantModelEditor.vue?vue&type=template&id=9f8ac41c&scoped=true&"
import script from "./BasicTenantModelEditor.vue?vue&type=script&lang=ts&"
export * from "./BasicTenantModelEditor.vue?vue&type=script&lang=ts&"
import style0 from "./BasicTenantModelEditor.vue?vue&type=style&index=0&id=9f8ac41c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8ac41c",
  null
  
)

export default component.exports